<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true
                    ? 'Festival Banner'
                    : 'Deleted Festival Banner'
                "
              ></h3>
              <template v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/festival-banners/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </template>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="285"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>&nbsp; Sr. No.</th>
                      <th class="text-left" style="min-width: none">Status</th>
                      <th class="text-left" style="min-width: none">Title</th>
                      <th class="text-left" style="min-width: none">
                        Description
                      </th>
                      <th class="text-left" style="min-width: none">
                        Start Date
                      </th>
                      <th class="text-left" style="min-width: none">
                        End Date
                      </th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="festival_banners.length != 0">
                    <tr
                      v-for="(festival_banner, i) in festival_banners"
                      :key="`festival_banner_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': festival_banners.length - 1 == i,
                      }"
                    >
                      <td>&nbsp;{{ i + 1 }}</td>
                      <td>
                        <v-tooltip bottom v-if="festival_banner.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Banner is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="festival_banner.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Banner is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ festival_banner.title || "" }}
                      </td>
                      <td>
                        {{ festival_banner.description || "" }}
                      </td>
                      <td>
                        {{ festival_banner.start_date || "" }}
                      </td>
                      <td>
                        {{ festival_banner.end_date || "" }}
                      </td>
                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/festival-banners/${encryptIt(
                                  festival_banner.id
                                )}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this Festival Banner</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="7" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_festival_banner" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Raw Material deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_festival_banner = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "FestivalBannersPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_selected: false,
        photo_path: "",
      },
      festival_banners: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      ExportRawMaterialTypes: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,
      isExcelloading: false,
      delete_festival_banner: false,
      is_deleted_festival_banner: false,
      is_select_all: false,
      isDeleteAll: false,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`festival_banners?${query}`)
        .then((response) => {
          this.festival_banners = response.data.data;
          console.log("festivel_banners", this.festivel_banners);

          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    //Generate Excel
    async generateExcel() {
      let query = "search_keyword=" + this.filter.search_keyword;
      let response = await axios.get(`festival_banner_exports?${query}`);
      console.log(response.data.data);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
    },
    async Delete_this(id) {
      this.delete_festival_banner = true;
      await axios
        .post(`/festival_banners/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_festival_banner = false;
          this.is_deleted_festival_banner = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          window.location.href = "/auth/login";
        });
    },
    selectAll() {
      console.log(this.is_select_all);
      this.festival_banners.forEach((festival_banner) => {
        festival_banner.is_selected = this.is_select_all;
      });
    },
    async deleteAll() {
      this.isDeleteAll = true;
      this.is_deleted_festival_banner = true;
      let deleteallIds = [];
      this.festival_banners.forEach((festival_banner) => {
        if (festival_banner.is_selected) deleteallIds.push(festival_banner);
      });
      await axios
        .post("/festival_banners/alldelete", { deleteallIds })
        .then(() => {
          this.filter.status = "";
          this.getData();
        })
        .catch(function (error) {
          this.getData();
          console.log(error);
        });
      // let response = await axios.post(/sync_users/update_date_all, this.form);
      this.isDeleteAll = false;
    },
  },
};
</script>
